/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Comparison,
  ComparisonFullDetails,
  ComparisonStatistics,
  ComparisonStatus,
  CreateComparisonRequest,
  CreateComparisonResponse,
  CreateLineItemMatchGroupRequest,
  CreateRoomMatchGroupRequest,
  GetComparisonLogs200ResponseInner,
  GetRoomMatchGroupsResponse,
  LineItemMatchGroup,
  ListComparisonsResponse,
  Problem,
  RematchLineItems202Response,
  RematchLineItemsRequest,
  RematchRooms202Response,
  RematchRoomsRequest,
  RoomMatchGroup,
  UpdateComparisonNameRequest,
  UpdateComparisonStatusRequest,
  UpdateLineItemMatchGroup200Response,
  UpdateLineItemMatchGroupRequest,
  UpdateMatchGroupStatusRequest,
  UpdateRoomMatchConfirmationStatusRequest,
  UpdateRoomMatchRequest,
} from '../models/index';
import {
    ComparisonFromJSON,
    ComparisonToJSON,
    ComparisonFullDetailsFromJSON,
    ComparisonFullDetailsToJSON,
    ComparisonStatisticsFromJSON,
    ComparisonStatisticsToJSON,
    ComparisonStatusFromJSON,
    ComparisonStatusToJSON,
    CreateComparisonRequestFromJSON,
    CreateComparisonRequestToJSON,
    CreateComparisonResponseFromJSON,
    CreateComparisonResponseToJSON,
    CreateLineItemMatchGroupRequestFromJSON,
    CreateLineItemMatchGroupRequestToJSON,
    CreateRoomMatchGroupRequestFromJSON,
    CreateRoomMatchGroupRequestToJSON,
    GetComparisonLogs200ResponseInnerFromJSON,
    GetComparisonLogs200ResponseInnerToJSON,
    GetRoomMatchGroupsResponseFromJSON,
    GetRoomMatchGroupsResponseToJSON,
    LineItemMatchGroupFromJSON,
    LineItemMatchGroupToJSON,
    ListComparisonsResponseFromJSON,
    ListComparisonsResponseToJSON,
    ProblemFromJSON,
    ProblemToJSON,
    RematchLineItems202ResponseFromJSON,
    RematchLineItems202ResponseToJSON,
    RematchLineItemsRequestFromJSON,
    RematchLineItemsRequestToJSON,
    RematchRooms202ResponseFromJSON,
    RematchRooms202ResponseToJSON,
    RematchRoomsRequestFromJSON,
    RematchRoomsRequestToJSON,
    RoomMatchGroupFromJSON,
    RoomMatchGroupToJSON,
    UpdateComparisonNameRequestFromJSON,
    UpdateComparisonNameRequestToJSON,
    UpdateComparisonStatusRequestFromJSON,
    UpdateComparisonStatusRequestToJSON,
    UpdateLineItemMatchGroup200ResponseFromJSON,
    UpdateLineItemMatchGroup200ResponseToJSON,
    UpdateLineItemMatchGroupRequestFromJSON,
    UpdateLineItemMatchGroupRequestToJSON,
    UpdateMatchGroupStatusRequestFromJSON,
    UpdateMatchGroupStatusRequestToJSON,
    UpdateRoomMatchConfirmationStatusRequestFromJSON,
    UpdateRoomMatchConfirmationStatusRequestToJSON,
    UpdateRoomMatchRequestFromJSON,
    UpdateRoomMatchRequestToJSON,
} from '../models/index';

export interface CreateComparisonOperationRequest {
    createComparisonRequest: CreateComparisonRequest;
}

export interface CreateLineItemMatchGroupOperationRequest {
    createLineItemMatchGroupRequest: CreateLineItemMatchGroupRequest;
}

export interface CreateRoomMatchRequest {
    id: number;
    createRoomMatchGroupRequest: CreateRoomMatchGroupRequest;
}

export interface DeleteComparisonRequest {
    id: number;
}

export interface DeleteLineItemMatchGroupRequest {
    id: number;
}

export interface DeleteRoomMatchRequest {
    id: number;
}

export interface ExportComparisonExcelRequest {
    id: number;
}

export interface GetComparisonRequest {
    id: number;
}

export interface GetComparisonDetailsRequest {
    id: number;
}

export interface GetComparisonLogsRequest {
    id: number;
}

export interface GetComparisonStatisticsRequest {
    id: number;
}

export interface GetComparisonsRequest {
    claimId?: number;
    status?: ComparisonStatus;
    page?: number;
    limit?: number;
}

export interface GetRoomMatchesRequest {
    id: number;
    page?: number;
    limit?: number;
}

export interface RematchLineItemsOperationRequest {
    id: number;
    rematchLineItemsRequest: RematchLineItemsRequest;
}

export interface RematchRoomsOperationRequest {
    id: number;
    rematchRoomsRequest: RematchRoomsRequest;
}

export interface UpdateComparisonNameOperationRequest {
    id: number;
    updateComparisonNameRequest: UpdateComparisonNameRequest;
}

export interface UpdateComparisonStatusOperationRequest {
    id: number;
    updateComparisonStatusRequest: UpdateComparisonStatusRequest;
}

export interface UpdateLineItemMatchGroupOperationRequest {
    id: number;
    updateLineItemMatchGroupRequest: UpdateLineItemMatchGroupRequest;
}

export interface UpdateLineItemMatchGroupStatusRequest {
    id: number;
    updateMatchGroupStatusRequest: UpdateMatchGroupStatusRequest;
}

export interface UpdateRoomMatchOperationRequest {
    id: number;
    updateRoomMatchRequest: UpdateRoomMatchRequest;
}

export interface UpdateRoomMatchConfirmationStatusOperationRequest {
    id: number;
    updateRoomMatchConfirmationStatusRequest: UpdateRoomMatchConfirmationStatusRequest;
}

/**
 * ComparisonsApi - interface
 * 
 * @export
 * @interface ComparisonsApiInterface
 */
export interface ComparisonsApiInterface {
    /**
     * Create a new comparison between an insurer estimate and contractor estimate
     * @summary Create a new comparison
     * @param {CreateComparisonRequest} createComparisonRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparisonsApiInterface
     */
    createComparisonRaw(requestParameters: CreateComparisonOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateComparisonResponse>>;

    /**
     * Create a new comparison between an insurer estimate and contractor estimate
     * Create a new comparison
     */
    createComparison(requestParameters: CreateComparisonOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateComparisonResponse>;

    /**
     * Create a new manual line item match group
     * @summary Create a line item match group
     * @param {CreateLineItemMatchGroupRequest} createLineItemMatchGroupRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparisonsApiInterface
     */
    createLineItemMatchGroupRaw(requestParameters: CreateLineItemMatchGroupOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LineItemMatchGroup>>;

    /**
     * Create a new manual line item match group
     * Create a line item match group
     */
    createLineItemMatchGroup(requestParameters: CreateLineItemMatchGroupOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LineItemMatchGroup>;

    /**
     * Create a new room match group
     * @summary Create a room match
     * @param {number} id Comparison ID
     * @param {CreateRoomMatchGroupRequest} createRoomMatchGroupRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparisonsApiInterface
     */
    createRoomMatchRaw(requestParameters: CreateRoomMatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoomMatchGroup>>;

    /**
     * Create a new room match group
     * Create a room match
     */
    createRoomMatch(requestParameters: CreateRoomMatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoomMatchGroup>;

    /**
     * Delete a comparison by ID
     * @summary Delete a comparison
     * @param {number} id Comparison ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparisonsApiInterface
     */
    deleteComparisonRaw(requestParameters: DeleteComparisonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete a comparison by ID
     * Delete a comparison
     */
    deleteComparison(requestParameters: DeleteComparisonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Delete a line item match group
     * @summary Delete a line item match group
     * @param {number} id Line item match group ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparisonsApiInterface
     */
    deleteLineItemMatchGroupRaw(requestParameters: DeleteLineItemMatchGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete a line item match group
     * Delete a line item match group
     */
    deleteLineItemMatchGroup(requestParameters: DeleteLineItemMatchGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Delete a room match group
     * @summary Delete a room match
     * @param {number} id Room match group ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparisonsApiInterface
     */
    deleteRoomMatchRaw(requestParameters: DeleteRoomMatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete a room match group
     * Delete a room match
     */
    deleteRoomMatch(requestParameters: DeleteRoomMatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Generate and download an Excel report for the comparison
     * @summary Export comparison to Excel
     * @param {number} id Comparison ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparisonsApiInterface
     */
    exportComparisonExcelRaw(requestParameters: ExportComparisonExcelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>>;

    /**
     * Generate and download an Excel report for the comparison
     * Export comparison to Excel
     */
    exportComparisonExcel(requestParameters: ExportComparisonExcelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob>;

    /**
     * Retrieve details for a specific comparison
     * @summary Get comparison details
     * @param {number} id Comparison ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparisonsApiInterface
     */
    getComparisonRaw(requestParameters: GetComparisonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Comparison>>;

    /**
     * Retrieve details for a specific comparison
     * Get comparison details
     */
    getComparison(requestParameters: GetComparisonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Comparison>;

    /**
     * Returns comparison data in a flat, normalized structure optimized for UI operations.  Key features: - All line items include embedded match status (lineItemMatchGroup, roomMatchGroupId) - Match groups contain only IDs, not nested full entity details - Enables O(1) lookups by ID in the frontend - Easy filtering for unmatched items - Simpler state updates for UI operations - Optimized for modern frontend state management (Redux normalized state pattern)  Use this endpoint when you need to: - Move line items between rooms or match groups - Create/edit/delete match groups - Filter or display unmatched items - Perform any UI operations that manipulate matches 
     * @summary Get comparison with complete details
     * @param {number} id Comparison ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparisonsApiInterface
     */
    getComparisonDetailsRaw(requestParameters: GetComparisonDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ComparisonFullDetails>>;

    /**
     * Returns comparison data in a flat, normalized structure optimized for UI operations.  Key features: - All line items include embedded match status (lineItemMatchGroup, roomMatchGroupId) - Match groups contain only IDs, not nested full entity details - Enables O(1) lookups by ID in the frontend - Easy filtering for unmatched items - Simpler state updates for UI operations - Optimized for modern frontend state management (Redux normalized state pattern)  Use this endpoint when you need to: - Move line items between rooms or match groups - Create/edit/delete match groups - Filter or display unmatched items - Perform any UI operations that manipulate matches 
     * Get comparison with complete details
     */
    getComparisonDetails(requestParameters: GetComparisonDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ComparisonFullDetails>;

    /**
     * Retrieve reasoning logs for a comparison. Returns the same data structure as SSE snapshot events, allowing the UI widget to display logs for both in-progress and finished comparison runs. 
     * @summary Get comparison logs
     * @param {number} id Comparison ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparisonsApiInterface
     */
    getComparisonLogsRaw(requestParameters: GetComparisonLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetComparisonLogs200ResponseInner>>>;

    /**
     * Retrieve reasoning logs for a comparison. Returns the same data structure as SSE snapshot events, allowing the UI widget to display logs for both in-progress and finished comparison runs. 
     * Get comparison logs
     */
    getComparisonLogs(requestParameters: GetComparisonLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetComparisonLogs200ResponseInner>>;

    /**
     * Get detailed statistics for a comparison including: - Money found (difference between contractor and insurer estimates) - Line item match statistics - Room match statistics - Time tracking and processing duration - Match rates and unmatched item counts 
     * @summary Get comparison statistics
     * @param {number} id Comparison ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparisonsApiInterface
     */
    getComparisonStatisticsRaw(requestParameters: GetComparisonStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ComparisonStatistics>>;

    /**
     * Get detailed statistics for a comparison including: - Money found (difference between contractor and insurer estimates) - Line item match statistics - Room match statistics - Time tracking and processing duration - Match rates and unmatched item counts 
     * Get comparison statistics
     */
    getComparisonStatistics(requestParameters: GetComparisonStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ComparisonStatistics>;

    /**
     * Retrieve a paginated list of comparisons
     * @summary List comparisons
     * @param {number} [claimId] Filter comparisons by claim ID
     * @param {ComparisonStatus} [status] Filter comparisons by status
     * @param {number} [page] Page number for pagination
     * @param {number} [limit] Number of items per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparisonsApiInterface
     */
    getComparisonsRaw(requestParameters: GetComparisonsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListComparisonsResponse>>;

    /**
     * Retrieve a paginated list of comparisons
     * List comparisons
     */
    getComparisons(requestParameters: GetComparisonsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListComparisonsResponse>;

    /**
     * Retrieve all room match groups for a specific comparison
     * @summary Get room matches for a comparison
     * @param {number} id Comparison ID
     * @param {number} [page] Page number
     * @param {number} [limit] Items per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparisonsApiInterface
     */
    getRoomMatchesRaw(requestParameters: GetRoomMatchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetRoomMatchGroupsResponse>>;

    /**
     * Retrieve all room match groups for a specific comparison
     * Get room matches for a comparison
     */
    getRoomMatches(requestParameters: GetRoomMatchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetRoomMatchGroupsResponse>;

    /**
     * Run partial AI matching pipeline for specific room groups. Supports many-to-many room matching where multiple rooms from each side can be combined. This endpoint will: - Fetch existing comparison and room data - Fetch line items for all specified rooms - Run partial pipeline (line items only, skip level and room matching) - Merge new results into existing comparison - Return complete updated matching result 
     * @summary Rematch line items for specific room groups (many-to-many)
     * @param {number} id Comparison ID
     * @param {RematchLineItemsRequest} rematchLineItemsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparisonsApiInterface
     */
    rematchLineItemsRaw(requestParameters: RematchLineItemsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RematchLineItems202Response>>;

    /**
     * Run partial AI matching pipeline for specific room groups. Supports many-to-many room matching where multiple rooms from each side can be combined. This endpoint will: - Fetch existing comparison and room data - Fetch line items for all specified rooms - Run partial pipeline (line items only, skip level and room matching) - Merge new results into existing comparison - Return complete updated matching result 
     * Rematch line items for specific room groups (many-to-many)
     */
    rematchLineItems(requestParameters: RematchLineItemsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RematchLineItems202Response>;

    /**
     * Run partial AI matching pipeline for a specific level pair. This endpoint will: - Fetch existing comparison and document data - Find the specified levels by ID - Run partial pipeline (rooms + line items, skip level matching) - Merge new results into existing comparison - Return complete updated matching result 
     * @summary Rematch rooms for a specific level pair
     * @param {number} id Comparison ID
     * @param {RematchRoomsRequest} rematchRoomsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparisonsApiInterface
     */
    rematchRoomsRaw(requestParameters: RematchRoomsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RematchRooms202Response>>;

    /**
     * Run partial AI matching pipeline for a specific level pair. This endpoint will: - Fetch existing comparison and document data - Find the specified levels by ID - Run partial pipeline (rooms + line items, skip level matching) - Merge new results into existing comparison - Return complete updated matching result 
     * Rematch rooms for a specific level pair
     */
    rematchRooms(requestParameters: RematchRoomsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RematchRooms202Response>;

    /**
     * Update the display name of a comparison
     * @summary Update comparison name
     * @param {number} id Comparison ID
     * @param {UpdateComparisonNameRequest} updateComparisonNameRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparisonsApiInterface
     */
    updateComparisonNameRaw(requestParameters: UpdateComparisonNameOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Comparison>>;

    /**
     * Update the display name of a comparison
     * Update comparison name
     */
    updateComparisonName(requestParameters: UpdateComparisonNameOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Comparison>;

    /**
     * Update the status of a comparison
     * @summary Update comparison status
     * @param {number} id Comparison ID
     * @param {UpdateComparisonStatusRequest} updateComparisonStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparisonsApiInterface
     */
    updateComparisonStatusRaw(requestParameters: UpdateComparisonStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Comparison>>;

    /**
     * Update the status of a comparison
     * Update comparison status
     */
    updateComparisonStatus(requestParameters: UpdateComparisonStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Comparison>;

    /**
     * Assign a line item to a match group or remove it from its current match group
     * @summary Update a line item match group assignment
     * @param {number} id Line item ID
     * @param {UpdateLineItemMatchGroupRequest} updateLineItemMatchGroupRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparisonsApiInterface
     */
    updateLineItemMatchGroupRaw(requestParameters: UpdateLineItemMatchGroupOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateLineItemMatchGroup200Response>>;

    /**
     * Assign a line item to a match group or remove it from its current match group
     * Update a line item match group assignment
     */
    updateLineItemMatchGroup(requestParameters: UpdateLineItemMatchGroupOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateLineItemMatchGroup200Response>;

    /**
     * Update the status of a line item match group
     * @summary Update line item match group status
     * @param {number} id Line item match group ID
     * @param {UpdateMatchGroupStatusRequest} updateMatchGroupStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparisonsApiInterface
     */
    updateLineItemMatchGroupStatusRaw(requestParameters: UpdateLineItemMatchGroupStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LineItemMatchGroup>>;

    /**
     * Update the status of a line item match group
     * Update line item match group status
     */
    updateLineItemMatchGroupStatus(requestParameters: UpdateLineItemMatchGroupStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LineItemMatchGroup>;

    /**
     * Update a room match group (add/remove rooms)
     * @summary Update room match
     * @param {number} id Room match group ID
     * @param {UpdateRoomMatchRequest} updateRoomMatchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparisonsApiInterface
     */
    updateRoomMatchRaw(requestParameters: UpdateRoomMatchOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoomMatchGroup>>;

    /**
     * Update a room match group (add/remove rooms)
     * Update room match
     */
    updateRoomMatch(requestParameters: UpdateRoomMatchOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoomMatchGroup>;

    /**
     * Update the confirmation status of a room match group
     * @summary Update room match confirmation status
     * @param {number} id Room match group ID
     * @param {UpdateRoomMatchConfirmationStatusRequest} updateRoomMatchConfirmationStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparisonsApiInterface
     */
    updateRoomMatchConfirmationStatusRaw(requestParameters: UpdateRoomMatchConfirmationStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoomMatchGroup>>;

    /**
     * Update the confirmation status of a room match group
     * Update room match confirmation status
     */
    updateRoomMatchConfirmationStatus(requestParameters: UpdateRoomMatchConfirmationStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoomMatchGroup>;

}

/**
 * 
 */
export class ComparisonsApi extends runtime.BaseAPI implements ComparisonsApiInterface {

    /**
     * Create a new comparison between an insurer estimate and contractor estimate
     * Create a new comparison
     */
    async createComparisonRaw(requestParameters: CreateComparisonOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateComparisonResponse>> {
        if (requestParameters['createComparisonRequest'] == null) {
            throw new runtime.RequiredError(
                'createComparisonRequest',
                'Required parameter "createComparisonRequest" was null or undefined when calling createComparison().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/comparisons`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateComparisonRequestToJSON(requestParameters['createComparisonRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateComparisonResponseFromJSON(jsonValue));
    }

    /**
     * Create a new comparison between an insurer estimate and contractor estimate
     * Create a new comparison
     */
    async createComparison(requestParameters: CreateComparisonOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateComparisonResponse> {
        const response = await this.createComparisonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new manual line item match group
     * Create a line item match group
     */
    async createLineItemMatchGroupRaw(requestParameters: CreateLineItemMatchGroupOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LineItemMatchGroup>> {
        if (requestParameters['createLineItemMatchGroupRequest'] == null) {
            throw new runtime.RequiredError(
                'createLineItemMatchGroupRequest',
                'Required parameter "createLineItemMatchGroupRequest" was null or undefined when calling createLineItemMatchGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/comparisons/line-item-match-groups`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateLineItemMatchGroupRequestToJSON(requestParameters['createLineItemMatchGroupRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LineItemMatchGroupFromJSON(jsonValue));
    }

    /**
     * Create a new manual line item match group
     * Create a line item match group
     */
    async createLineItemMatchGroup(requestParameters: CreateLineItemMatchGroupOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LineItemMatchGroup> {
        const response = await this.createLineItemMatchGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new room match group
     * Create a room match
     */
    async createRoomMatchRaw(requestParameters: CreateRoomMatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoomMatchGroup>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createRoomMatch().'
            );
        }

        if (requestParameters['createRoomMatchGroupRequest'] == null) {
            throw new runtime.RequiredError(
                'createRoomMatchGroupRequest',
                'Required parameter "createRoomMatchGroupRequest" was null or undefined when calling createRoomMatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/comparisons/{id}/room-matches`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateRoomMatchGroupRequestToJSON(requestParameters['createRoomMatchGroupRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoomMatchGroupFromJSON(jsonValue));
    }

    /**
     * Create a new room match group
     * Create a room match
     */
    async createRoomMatch(requestParameters: CreateRoomMatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoomMatchGroup> {
        const response = await this.createRoomMatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a comparison by ID
     * Delete a comparison
     */
    async deleteComparisonRaw(requestParameters: DeleteComparisonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteComparison().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/comparisons/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a comparison by ID
     * Delete a comparison
     */
    async deleteComparison(requestParameters: DeleteComparisonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteComparisonRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a line item match group
     * Delete a line item match group
     */
    async deleteLineItemMatchGroupRaw(requestParameters: DeleteLineItemMatchGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteLineItemMatchGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/comparisons/line-item-match-groups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a line item match group
     * Delete a line item match group
     */
    async deleteLineItemMatchGroup(requestParameters: DeleteLineItemMatchGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteLineItemMatchGroupRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a room match group
     * Delete a room match
     */
    async deleteRoomMatchRaw(requestParameters: DeleteRoomMatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteRoomMatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/comparisons/room-matches/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a room match group
     * Delete a room match
     */
    async deleteRoomMatch(requestParameters: DeleteRoomMatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteRoomMatchRaw(requestParameters, initOverrides);
    }

    /**
     * Generate and download an Excel report for the comparison
     * Export comparison to Excel
     */
    async exportComparisonExcelRaw(requestParameters: ExportComparisonExcelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling exportComparisonExcel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/comparisons/{id}/export/excel`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Generate and download an Excel report for the comparison
     * Export comparison to Excel
     */
    async exportComparisonExcel(requestParameters: ExportComparisonExcelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.exportComparisonExcelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve details for a specific comparison
     * Get comparison details
     */
    async getComparisonRaw(requestParameters: GetComparisonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Comparison>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getComparison().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/comparisons/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ComparisonFromJSON(jsonValue));
    }

    /**
     * Retrieve details for a specific comparison
     * Get comparison details
     */
    async getComparison(requestParameters: GetComparisonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Comparison> {
        const response = await this.getComparisonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns comparison data in a flat, normalized structure optimized for UI operations.  Key features: - All line items include embedded match status (lineItemMatchGroup, roomMatchGroupId) - Match groups contain only IDs, not nested full entity details - Enables O(1) lookups by ID in the frontend - Easy filtering for unmatched items - Simpler state updates for UI operations - Optimized for modern frontend state management (Redux normalized state pattern)  Use this endpoint when you need to: - Move line items between rooms or match groups - Create/edit/delete match groups - Filter or display unmatched items - Perform any UI operations that manipulate matches 
     * Get comparison with complete details
     */
    async getComparisonDetailsRaw(requestParameters: GetComparisonDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ComparisonFullDetails>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getComparisonDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/comparisons/{id}/details`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ComparisonFullDetailsFromJSON(jsonValue));
    }

    /**
     * Returns comparison data in a flat, normalized structure optimized for UI operations.  Key features: - All line items include embedded match status (lineItemMatchGroup, roomMatchGroupId) - Match groups contain only IDs, not nested full entity details - Enables O(1) lookups by ID in the frontend - Easy filtering for unmatched items - Simpler state updates for UI operations - Optimized for modern frontend state management (Redux normalized state pattern)  Use this endpoint when you need to: - Move line items between rooms or match groups - Create/edit/delete match groups - Filter or display unmatched items - Perform any UI operations that manipulate matches 
     * Get comparison with complete details
     */
    async getComparisonDetails(requestParameters: GetComparisonDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ComparisonFullDetails> {
        const response = await this.getComparisonDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve reasoning logs for a comparison. Returns the same data structure as SSE snapshot events, allowing the UI widget to display logs for both in-progress and finished comparison runs. 
     * Get comparison logs
     */
    async getComparisonLogsRaw(requestParameters: GetComparisonLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetComparisonLogs200ResponseInner>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getComparisonLogs().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/comparisons/{id}/logs`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetComparisonLogs200ResponseInnerFromJSON));
    }

    /**
     * Retrieve reasoning logs for a comparison. Returns the same data structure as SSE snapshot events, allowing the UI widget to display logs for both in-progress and finished comparison runs. 
     * Get comparison logs
     */
    async getComparisonLogs(requestParameters: GetComparisonLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetComparisonLogs200ResponseInner>> {
        const response = await this.getComparisonLogsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get detailed statistics for a comparison including: - Money found (difference between contractor and insurer estimates) - Line item match statistics - Room match statistics - Time tracking and processing duration - Match rates and unmatched item counts 
     * Get comparison statistics
     */
    async getComparisonStatisticsRaw(requestParameters: GetComparisonStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ComparisonStatistics>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getComparisonStatistics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/comparisons/{id}/statistics`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ComparisonStatisticsFromJSON(jsonValue));
    }

    /**
     * Get detailed statistics for a comparison including: - Money found (difference between contractor and insurer estimates) - Line item match statistics - Room match statistics - Time tracking and processing duration - Match rates and unmatched item counts 
     * Get comparison statistics
     */
    async getComparisonStatistics(requestParameters: GetComparisonStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ComparisonStatistics> {
        const response = await this.getComparisonStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve a paginated list of comparisons
     * List comparisons
     */
    async getComparisonsRaw(requestParameters: GetComparisonsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListComparisonsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['claimId'] != null) {
            queryParameters['claimId'] = requestParameters['claimId'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/comparisons`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListComparisonsResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve a paginated list of comparisons
     * List comparisons
     */
    async getComparisons(requestParameters: GetComparisonsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListComparisonsResponse> {
        const response = await this.getComparisonsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve all room match groups for a specific comparison
     * Get room matches for a comparison
     */
    async getRoomMatchesRaw(requestParameters: GetRoomMatchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetRoomMatchGroupsResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getRoomMatches().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/comparisons/{id}/room-matches`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetRoomMatchGroupsResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve all room match groups for a specific comparison
     * Get room matches for a comparison
     */
    async getRoomMatches(requestParameters: GetRoomMatchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetRoomMatchGroupsResponse> {
        const response = await this.getRoomMatchesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Run partial AI matching pipeline for specific room groups. Supports many-to-many room matching where multiple rooms from each side can be combined. This endpoint will: - Fetch existing comparison and room data - Fetch line items for all specified rooms - Run partial pipeline (line items only, skip level and room matching) - Merge new results into existing comparison - Return complete updated matching result 
     * Rematch line items for specific room groups (many-to-many)
     */
    async rematchLineItemsRaw(requestParameters: RematchLineItemsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RematchLineItems202Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rematchLineItems().'
            );
        }

        if (requestParameters['rematchLineItemsRequest'] == null) {
            throw new runtime.RequiredError(
                'rematchLineItemsRequest',
                'Required parameter "rematchLineItemsRequest" was null or undefined when calling rematchLineItems().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/comparisons/{id}/rematch/line-items`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RematchLineItemsRequestToJSON(requestParameters['rematchLineItemsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RematchLineItems202ResponseFromJSON(jsonValue));
    }

    /**
     * Run partial AI matching pipeline for specific room groups. Supports many-to-many room matching where multiple rooms from each side can be combined. This endpoint will: - Fetch existing comparison and room data - Fetch line items for all specified rooms - Run partial pipeline (line items only, skip level and room matching) - Merge new results into existing comparison - Return complete updated matching result 
     * Rematch line items for specific room groups (many-to-many)
     */
    async rematchLineItems(requestParameters: RematchLineItemsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RematchLineItems202Response> {
        const response = await this.rematchLineItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Run partial AI matching pipeline for a specific level pair. This endpoint will: - Fetch existing comparison and document data - Find the specified levels by ID - Run partial pipeline (rooms + line items, skip level matching) - Merge new results into existing comparison - Return complete updated matching result 
     * Rematch rooms for a specific level pair
     */
    async rematchRoomsRaw(requestParameters: RematchRoomsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RematchRooms202Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rematchRooms().'
            );
        }

        if (requestParameters['rematchRoomsRequest'] == null) {
            throw new runtime.RequiredError(
                'rematchRoomsRequest',
                'Required parameter "rematchRoomsRequest" was null or undefined when calling rematchRooms().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/comparisons/{id}/rematch/rooms`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RematchRoomsRequestToJSON(requestParameters['rematchRoomsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RematchRooms202ResponseFromJSON(jsonValue));
    }

    /**
     * Run partial AI matching pipeline for a specific level pair. This endpoint will: - Fetch existing comparison and document data - Find the specified levels by ID - Run partial pipeline (rooms + line items, skip level matching) - Merge new results into existing comparison - Return complete updated matching result 
     * Rematch rooms for a specific level pair
     */
    async rematchRooms(requestParameters: RematchRoomsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RematchRooms202Response> {
        const response = await this.rematchRoomsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the display name of a comparison
     * Update comparison name
     */
    async updateComparisonNameRaw(requestParameters: UpdateComparisonNameOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Comparison>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateComparisonName().'
            );
        }

        if (requestParameters['updateComparisonNameRequest'] == null) {
            throw new runtime.RequiredError(
                'updateComparisonNameRequest',
                'Required parameter "updateComparisonNameRequest" was null or undefined when calling updateComparisonName().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/comparisons/{id}/name`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateComparisonNameRequestToJSON(requestParameters['updateComparisonNameRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ComparisonFromJSON(jsonValue));
    }

    /**
     * Update the display name of a comparison
     * Update comparison name
     */
    async updateComparisonName(requestParameters: UpdateComparisonNameOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Comparison> {
        const response = await this.updateComparisonNameRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the status of a comparison
     * Update comparison status
     */
    async updateComparisonStatusRaw(requestParameters: UpdateComparisonStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Comparison>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateComparisonStatus().'
            );
        }

        if (requestParameters['updateComparisonStatusRequest'] == null) {
            throw new runtime.RequiredError(
                'updateComparisonStatusRequest',
                'Required parameter "updateComparisonStatusRequest" was null or undefined when calling updateComparisonStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/comparisons/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateComparisonStatusRequestToJSON(requestParameters['updateComparisonStatusRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ComparisonFromJSON(jsonValue));
    }

    /**
     * Update the status of a comparison
     * Update comparison status
     */
    async updateComparisonStatus(requestParameters: UpdateComparisonStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Comparison> {
        const response = await this.updateComparisonStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Assign a line item to a match group or remove it from its current match group
     * Update a line item match group assignment
     */
    async updateLineItemMatchGroupRaw(requestParameters: UpdateLineItemMatchGroupOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateLineItemMatchGroup200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateLineItemMatchGroup().'
            );
        }

        if (requestParameters['updateLineItemMatchGroupRequest'] == null) {
            throw new runtime.RequiredError(
                'updateLineItemMatchGroupRequest',
                'Required parameter "updateLineItemMatchGroupRequest" was null or undefined when calling updateLineItemMatchGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/comparisons/line-items/{id}/match-group`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLineItemMatchGroupRequestToJSON(requestParameters['updateLineItemMatchGroupRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateLineItemMatchGroup200ResponseFromJSON(jsonValue));
    }

    /**
     * Assign a line item to a match group or remove it from its current match group
     * Update a line item match group assignment
     */
    async updateLineItemMatchGroup(requestParameters: UpdateLineItemMatchGroupOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateLineItemMatchGroup200Response> {
        const response = await this.updateLineItemMatchGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the status of a line item match group
     * Update line item match group status
     */
    async updateLineItemMatchGroupStatusRaw(requestParameters: UpdateLineItemMatchGroupStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LineItemMatchGroup>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateLineItemMatchGroupStatus().'
            );
        }

        if (requestParameters['updateMatchGroupStatusRequest'] == null) {
            throw new runtime.RequiredError(
                'updateMatchGroupStatusRequest',
                'Required parameter "updateMatchGroupStatusRequest" was null or undefined when calling updateLineItemMatchGroupStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/comparisons/line-item-match-groups/{id}/status`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateMatchGroupStatusRequestToJSON(requestParameters['updateMatchGroupStatusRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LineItemMatchGroupFromJSON(jsonValue));
    }

    /**
     * Update the status of a line item match group
     * Update line item match group status
     */
    async updateLineItemMatchGroupStatus(requestParameters: UpdateLineItemMatchGroupStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LineItemMatchGroup> {
        const response = await this.updateLineItemMatchGroupStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a room match group (add/remove rooms)
     * Update room match
     */
    async updateRoomMatchRaw(requestParameters: UpdateRoomMatchOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoomMatchGroup>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateRoomMatch().'
            );
        }

        if (requestParameters['updateRoomMatchRequest'] == null) {
            throw new runtime.RequiredError(
                'updateRoomMatchRequest',
                'Required parameter "updateRoomMatchRequest" was null or undefined when calling updateRoomMatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/comparisons/room-matches/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateRoomMatchRequestToJSON(requestParameters['updateRoomMatchRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoomMatchGroupFromJSON(jsonValue));
    }

    /**
     * Update a room match group (add/remove rooms)
     * Update room match
     */
    async updateRoomMatch(requestParameters: UpdateRoomMatchOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoomMatchGroup> {
        const response = await this.updateRoomMatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the confirmation status of a room match group
     * Update room match confirmation status
     */
    async updateRoomMatchConfirmationStatusRaw(requestParameters: UpdateRoomMatchConfirmationStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoomMatchGroup>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateRoomMatchConfirmationStatus().'
            );
        }

        if (requestParameters['updateRoomMatchConfirmationStatusRequest'] == null) {
            throw new runtime.RequiredError(
                'updateRoomMatchConfirmationStatusRequest',
                'Required parameter "updateRoomMatchConfirmationStatusRequest" was null or undefined when calling updateRoomMatchConfirmationStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/comparisons/room-matches/{id}/confirmation`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateRoomMatchConfirmationStatusRequestToJSON(requestParameters['updateRoomMatchConfirmationStatusRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoomMatchGroupFromJSON(jsonValue));
    }

    /**
     * Update the confirmation status of a room match group
     * Update room match confirmation status
     */
    async updateRoomMatchConfirmationStatus(requestParameters: UpdateRoomMatchConfirmationStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoomMatchGroup> {
        const response = await this.updateRoomMatchConfirmationStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
